module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjY2NjMgNi41TDkuNzQ5NjcgMTguNDE2N0w0LjMzMzAxIDEzIiBzdHJva2U9IiM5QTMwN0EiIHN0cm9rZS13aWR0aD0iMi4xNjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/icon/svg/check_magenta.svg
// module id = 5nRd
// module chunks = 8